const fieldsTable = [
  {
    key: "actions",
    label: "Actions",
    user: "superUser"
  },
  {
    key: "id",
    label: "ID",
    class: "text-center"
  },
  {
    key: "subject",
    label: "SUBJECT",
    user: "superUser"
  },
  {
    key: "customers",
    label: "CUSTOMERS",
    user: "superUser"
  },
  {
    key: "client_email",
    label: "CLIENT EMAIL",
    user: "superUser"
  },
  {
    key: "language_classification",
    label: "LANGUAGE",
    user: "superUser"
  },
  {
    key: "canned_response",
    label: "CANNED RESPONSE",
    user: "superUser"
  },
  {
    key: "created_at",
    label: "CREATED AT",
    user: "superUser"
  },
  /* {
    key: "mode",
    label: "MODE",
    user: "superUser"
  }, */
  {
    key: "assigned_to",
    label: "ASSIGNED TO",
    user: "superUser"
  },
  {
    key: "cause_of_return",
    label: "CAUSE OF RETURN MAIL",
    user: "cause_of_return"
  },
  {
    key: "send_to_hypercubes",
    label: "SEND TO HYPERCUBES",
    user: "superUser"
  }
];

const fields = [
  { key: "actions", label: "Actions" },
  {
    key: "id",
    label: "ID",
    class: "text-center"
  },
  {
    key: "subject",
    label: "SUBJECT",
    sortDirection: "desc"
  },
  {
    key: "last_modified",
    label: "LAST MODIFIED",
    sortDirection: "desc"
  },
  {
    key: "created_at",
    label: "CREATED AT",
    user: "superUser"
  },
  {
    key: "assigned_to",
    label: "ASSIGNED TO",
    sortDirection: "desc"
  }
];

module.exports = { fieldsTable, fields };
